const BITIBA_FONTS = `
  @font-face {
    font-family: Patrick Hand;
    font-style: normal;
    font-weight: 400;
    src: local(),
      url(https://cdn.public.zooplus.net/media/ui-components/v6-latest/fonts/patrick-hand-latin-regular.woff2)
        format(woff2), url(https://cdn.public.zooplus.net/media/ui-components/v6-latest/fonts/patrick-hand-latin-regular.woff
        format(woff);
  }
  @font-face {
    font-family: Roboto Slab;
    font-style: normal;
    font-weight: 700;
    src: local(),
      url(https://cdn.public.zooplus.net/media/ui-components/v6-latest/fonts/roboto-slab-latin-700.woff2)
        format(woff2), url(https://cdn.public.zooplus.net/media/ui-components/v6-latest/fonts/roboto-slab-latin-700.woff)
        format(woff);
  }
`;

const ZOOPLUS_FONTS = `
    @font-face {
      font-family: Nunito;
      font-style: normal;
      font-weight: 400;
      src: url(https://cdn.public.zooplus.net/media/ui-components/v6-latest/fonts/nunito-cyrillic_latin-regular.woff2) format(woff2);
    }

    @font-face {
      font-family: Nunito;
      font-style: italic;
      font-weight: 400;
      src: url(https://cdn.public.zooplus.net/media/ui-components/v6-latest/fonts/nunito-cyrillic_latin-italic.woff2) format(woff2);
    }

    @font-face {
      font-family: Nunito;
      font-style: normal;
      font-weight: 500;
      src: url(https://cdn.public.zooplus.net/media/ui-components/v6-latest/fonts/nunito-cyrillic_latin-500.woff2) format(woff2);
    }

    @font-face {
      font-family: Nunito;
      font-style: normal;
      font-weight: 700;
      src: url(https://cdn.public.zooplus.net/media/ui-components/v6-latest/fonts/nunito-cyrillic_latin-700.woff2) format(woff2);
    }
  `;

const THEME_FONTS = {
    zooplus: ZOOPLUS_FONTS,
    bitiba: BITIBA_FONTS,
};

export const getWebFonts = (isBitiba: boolean): string => {
    return isBitiba ? THEME_FONTS.bitiba : THEME_FONTS.zooplus;
};
